import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Tag } from '../../Elements/Tag/index.js';
import { Tooltip } from '../../Feedback/Tooltip/index.js';
import { Wrapper, List, ListItem, ClickableItem, ClickableListItemRow } from './styled.js';
export {} from './types.js';
const openLink = (link) => window.open(link, '_blank');
const renderVisibleItem = (item, index, isLast) => {
    const content = item.title + (isLast ? '' : ', ');
    if (item.link) {
        return (_jsx(ClickableItem, { onClick: () => openLink(item.link), children: content }, `${item.title}-${index}`));
    }
    return _jsx("span", { children: content }, `${item.title}-${index}`);
};
const renderHiddenItem = (item, index) => {
    const key = `${item.title}-${index}`;
    if (item.link) {
        return (_jsx(ClickableListItemRow, { "data-testid": 'list-counter-item', onClick: () => openLink(item.link), children: item.title }, key));
    }
    return (_jsx(ListItem, { "data-testid": 'list-counter-item', children: item.title }, key));
};
export const ListWithCounter = React.memo(function ListWithCounter(props) {
    const { defaultVisibleItems = 1 } = props;
    const items = props.list
        ? props.list.map((title) => ({ title }))
        : (props.linksList ?? []).map(({ title, link }) => ({ title, link }));
    if (items.length === 0) {
        return null;
    }
    const visibleItems = items.slice(0, defaultVisibleItems);
    const hiddenItems = items.slice(defaultVisibleItems);
    return (_jsxs(Wrapper, { "data-testid": 'content-wrapper', children: [visibleItems.map((item, index) => renderVisibleItem(item, index, index === visibleItems.length - 1)), hiddenItems.length > 0 && (_jsx(Tooltip, { type: 'popper', contentPadding: false, delayHide: 150, trigger: ['hover', 'click'], dataTestId: 'list-counter-tooltip', tooltip: _jsx(List, { children: hiddenItems.map((item, index) => renderHiddenItem(item, index)) }), children: _jsx(Tag, { dataTestId: 'list-counter-tag', title: ` +${hiddenItems.length}` }) }))] }));
});
